

function filterDescription(obj) {
  var selector, objs;
  selector = '.collection-filter-list li button';
  objs = document.querySelectorAll(selector);
  for (var i = 0; i < objs.length; i++)
        objs[i].classList.remove('active');
  obj.classList.add('active');
  
  document.getElementById("collectionTitle").innerHTML = obj.getAttribute('data-title');
  document.getElementById("collectionDescription").innerHTML = obj.getAttribute('data-desc') + ' <br><a href="/collections/' + obj.value + '" class="link animate-arrow">View products</a>';
  document.getElementById("fragrance-icon").className = "";
  document.getElementById("fragrance-icon").classList.add("icon-" + obj.value);

  notes = document.getElementById("notes");
  notes.innerHTML = "";
  if (obj.value === "no-4-orange-vanilla") {
    notes.innerHTML = "Brazilian Orange | Tahitian Vanilla | Tonka Bean";
  }
  if (obj.value === "no-7-patchouli-sandalwood") {
    notes.innerHTML = "Asiatic Patchouli | Sandalwood | Cedar";
  }
  if (obj.value === "no-8-fresh-cut-tuberose") {
    notes.innerHTML = "French Tuberose | Heady White Florals | Fresh Green Notes";
  }
  if (obj.value === "no-10-lemongrass-verbena") {
    notes.innerHTML = "Asian Lemongrass | Brazilian Verbena | Indonesian Vanilla";
  }
  if (obj.value === "no-13-bobs-flower-shoppe") {
    notes.innerHTML = "Fresh Florals | Cut Green Stems | Watery Accords";
  }
  if (obj.value === "no-14-mediterranean-fig") {
    notes.innerHTML = "Tuscan Fig | Fresh Melon | Blonde Woods";
  }
  if (obj.value === "no-20-water") {
    notes.innerHTML = "Fresh Ozone | Aqueous Notes | White Florals";
  }
  if (obj.value === "no-21-amber-bergamot") {
    notes.innerHTML = "Aromatic Bergamot | Warm Amber | Cashmere Woods";
  }
  if (obj.value === "no-24-wild-currant") {
    notes.innerHTML = "Red Currant | Cassis Noir | Spanish Moss";
  }
  if (obj.value === "no-25-lavender-de-provence") {
    notes.innerHTML = "French Lavender | Clary Sage | Vanilla Orchid";
  }
  if (obj.value === "no-28-bamboo-citrus") {
    notes.innerHTML = "Japanese Bamboo | White Grapefruit | Raw Sugar Cane";
  }
  if (obj.value === "no-39-sexy-cinnamon") {
    notes.innerHTML = "Natural Cinnamon | Aromatic Spices | Balsa Wood";
  }
  if (obj.value === "no-60-jasmine-gardenia") {
    notes.innerHTML = "Gardenia | Night Blooming Jasmine | Hint of Honeysuckle";
  }
  if (obj.value === "no-63-peony-rosewater") {
    notes.innerHTML = "Wild Peony | Rosewater | Woody Musk";
  }
  if (obj.value === "no-64-coconut-blossom") {
    notes.innerHTML = "White Lotus | Orange Blossom | Coconut Milk";
  }
  if (obj.value === "no-68-teak-oud-wood") {
    notes.innerHTML = "Burmese Teak | Oud Wood | Madagascar Vanilla";
  }
  if (obj.value === "no-72-amalfi-citron") {
    notes.innerHTML = "Capri Lemon | Tropical Fruits | Sparkling Champagne";
  }
  if (obj.value === "no-73-vetiver-seagrass") {
    notes.innerHTML = "Ozone | Satsuma Mandarin | Fresh Vetiver";
  }
  if (obj.value === "no-74-tabac-leather") {
    notes.innerHTML = "French Tobacco | Grain Leather | Woody Incense";
  }
  if (obj.value === "no-75-hibiscus-prosecco") {
    notes.innerHTML = "Hawaiian Hibiscus | Ripe Pomelo | Vanilla Honey";
  }
  if (obj.value === "no-76-watermint-eucalyptus") {
    notes.innerHTML = "European Watermint | Fresh Eucalyptus | Indian Sandalwood";
  }
  if (obj.value === "no-77-palo-santo") {
    notes.innerHTML = "Peruvian Palo Santo | Oakmoss | Kashmiri Saffron";
  }
  if (obj.value === "no-78-ginger-sage") {
    notes.innerHTML = "Ginger Root | Garden Sage | Lemon Tea";
  }
  if (obj.value === "no-79-lemon-leaf-basil") {
    notes.innerHTML = "Meyer Lemon | Sweet Basil | Wild Lily";
  }
  if (obj.value === "no-80-vanilla-soft-musk") {
    notes.innerHTML = "Warm Baltic Amber | Cedarwood Musk | Vanilla Muscovado Sugar";
  }
  if (obj.value === "no-81-waterlily-driftwood") {
    notes.innerHTML = "Fresh Marine | Sea Salt Driftwood | Aquatic Floral";
  }
}